import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {UserProfileService} from './Services/user-profile/user-profile.service';
import * as LoginActions from './State/actions/login.actions';
import {selectUserLogged} from './State/selectors/index.selector';
import {TranslocoService} from '@ngneat/transloco';
import {environment} from 'src/environments/environment';
import Hotjar from '@hotjar/browser';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit , AfterViewInit{
  public appPages = [
    { title: 'Payment Methods', url: 'payment-methods', icon: 'card' },
    { title: 'Profile', url: 'profile', icon: 'person' },
    { title: 'Services', url: 'services', icon: 'card' },
    { title: 'Dashboard', url: 'dashboard', icon: 'bar-chart' },
    { title: 'Sign Up', url: 'sign-up', icon: 'bar-chart' }
  ];

  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  public userDataLoaded = false;

  constructor(
    private userProfileService: UserProfileService,
    private store: Store,
    private router: Router,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.userProfileService.user$.subscribe((userState) => {
      if (userState.user && userState.user.locale) {
        this.translocoService.load(userState.user.locale).subscribe(() => {
          this.translocoService.setActiveLang(userState.user.locale);
        });
      }
    });

    this
      .userProfileService
      .getUserProfile()
      .then(user => {
        this.store.dispatch(LoginActions.loginSuccess(user));
      })
      .catch(() => {
        this.userDataLoaded = true;
      });

    this
      .store
      .select(selectUserLogged)
      .subscribe((state) => {
        if (state.user && state.role) {
          this.userDataLoaded = true;
        }
      });
  }

  ngAfterViewInit(){
    if(environment.production || environment.homol){
      Hotjar.init(environment.hotjarId, 6);
    }
  }
}
